import { callZpayFunction } from '../../callZpayFunction';

// 장바구니 추가
export const addCart = () => {
  callZpayFunction('addCart')();
};
